const finite = (value, fallback) => Number.isFinite(value) ? value : fallback;
const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

export const chatViewport = () => {
  const viewport = window.visualViewport;
  return {
    left: (viewport?.offsetLeft || 0) + 8,
    top: (viewport?.offsetTop || 0) + 8,
    width: Math.max(1, (viewport?.width || window.innerWidth) - 16),
    height: Math.max(1, (viewport?.height || window.innerHeight) - 16),
  };
};

export const fitChatRect = (rect, bounds) => {
  const width = clamp(finite(rect?.width, 380), Math.min(280, bounds.width), bounds.width);
  const height = clamp(finite(rect?.height, 540), Math.min(280, bounds.height), bounds.height);
  return {
    x: clamp(finite(rect?.x, 12), 0, bounds.width - width),
    y: clamp(finite(rect?.y, bounds.height - height - 80), 0, bounds.height - height),
    width, height,
  };
};

export const resizeChatFromAnchor = (rect, size, bounds) => {
  const fitted = fitChatRect({ ...rect, ...size }, bounds);
  const nearRight = rect.x > (bounds.width - rect.width) / 2;
  const nearBottom = rect.y > (bounds.height - rect.height) / 2;
  return fitChatRect({ ...fitted,
    x: nearRight ? rect.x + rect.width - fitted.width : rect.x,
    y: nearBottom ? rect.y + rect.height - fitted.height : rect.y,
  }, bounds);
};

export const readChatRect = (key, fallback) => {
  try {
    const saved = JSON.parse(localStorage.getItem(key));
    return saved && ['x', 'y', 'width', 'height'].every(k => Number.isFinite(saved[k]))
      ? saved : fallback;
  } catch { return fallback; }
};

export const saveChatRect = (key, rect) => {
  try { localStorage.setItem(key, JSON.stringify(rect)); } catch { /* Optional display preference. */ }
};